import React from "react";
import Countdown from "./components/Countdown";
import "./App.css";

const App = () => {
  return <Countdown />;
};

export default App;
